import React from "react"
import { AppToolbarCreateButton } from "@components"
import {useUserSettingsSitesGroup} from "../@hooks";

export default function UserSettingSitesGroupTabButton() {
    const { handleSetSitesGroupFormData } = useUserSettingsSitesGroup()

    return <AppToolbarCreateButton
        label="Define Sites Group"
        onClick={handleSetSitesGroupFormData}
    />
}